/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from './date-field.component';
import * as import4 from '../field/field.component.ngfactory';
import * as import5 from '../field/field.component';
import * as import6 from '../form/form.component';
import * as import7 from '@angular/forms';
import * as import8 from '@angular/common';
import * as import9 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import10 from '../../ui-elements/icon/icon.component';
const styles_DateFieldComponent:any[] = ([] as any[]);
export const RenderType_DateFieldComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DateFieldComponent,
  data: {}
}
);
function View_DateFieldComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'date-field-placeholder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.placeholder,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
export function View_DateFieldComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{inputER: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'woa-field',([] as any[]),[[
        2,
        'no-message',
        (null as any)
      ]
      ],[[
        (null as any),
        'onActivateLink'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.DateFieldComponent = v.component;
      if (('onActivateLink' === en)) {
        const pd_0:any = ((<any>co.onActivateLink.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_FieldComponent_0,import4.RenderType_FieldComponent)),
    import0.ɵdid(49152,(null as any),1,import5.FieldComponent,[
      [
        2,
        import6.FormComponent
      ]
      ,
      [
        2,
        import7.NgControl
      ]

    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      message: [
        2,
        'message'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]
      ,
      readOnly: [
        4,
        'readOnly'
      ]
      ,
      disabled: [
        5,
        'disabled'
      ]
      ,
      defaultInput: [
        6,
        'defaultInput'
      ]

    }
    ,{onActivateLink: 'onActivateLink'}),
    import0.ɵqud(603979776,2,{models: 1}),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,14,'div',[[
        'class',
        'date-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'input',
        1
      ]

    ]
    ,(null as any),5,'input',[
      [
        'class',
        'date-field-input'
      ]
      ,
      [
        'type',
        'date'
      ]

    ]
    ,[
      [
        1,
        'id',
        0
      ]
      ,
      [
        1,
        'autocomplete',
        0
      ]
      ,
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.DateFieldComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.value = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import7.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import7.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import7.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.DefaultValueAccessor]),
      import0.ɵdid(671744,[[
        2,
        4
      ]
    ],0,import7.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import7.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import7.NgControl,(null as any),[import7.NgModel]),
    import0.ɵdid(16384,(null as any),0,import7.NgControlStatus,[import7.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DateFieldComponent_1)),
    import0.ɵdid(16384,(null as any),0,import8.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'date-field-icon'
      ]
    ],(null as any),(null as any),(null as any),import9.View_IconComponent_0,import9.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import10.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(0,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.DateFieldComponent = v.component;
    const currVal_1:any = co.label;
    const currVal_2:any = co.link;
    const currVal_3:any = co.message;
    const currVal_4:any = co.translationParams;
    const currVal_5:any = co.readOnly;
    const currVal_6:any = co.disabled;
    const currVal_7:any = import0.ɵnov(v,7);
    ck(v,2,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_18:any = co.value;
    ck(v,10,0,currVal_18);
    const currVal_19:boolean = !co.value;
    ck(v,15,0,currVal_19);
    const currVal_20:any = 'calendar';
    ck(v,18,0,currVal_20);
  },(ck,v) => {
    var co:import3.DateFieldComponent = v.component;
    const currVal_0:any = import0.ɵnov(v,2).noMessage;
    ck(v,1,0,currVal_0);
    const currVal_8:any = co.inputId;
    const currVal_9:any = co.autocomplete;
    const currVal_10:any = co.readOnly;
    const currVal_11:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_12:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_13:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_14:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_15:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_16:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_17:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,7,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17);
  });
}
function View_DateFieldComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-date-field',([] as any[]),(null as any),(null as any),(null as any),View_DateFieldComponent_0,RenderType_DateFieldComponent)),
    import0.ɵdid(180224,(null as any),0,import3.DateFieldComponent,[import0.ChangeDetectorRef],(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import7.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import3.DateFieldComponent])
  ]
  ,(null as any),(null as any));
}
export const DateFieldComponentNgFactory:import0.ComponentFactory<import3.DateFieldComponent> = import0.ɵccf('woa-date-field',import3.DateFieldComponent,View_DateFieldComponent_Host_0,{
  inputId: 'inputId',
  label: 'label',
  link: 'link',
  placeholder: 'placeholder',
  message: 'message',
  translationParams: 'translationParams',
  readOnly: 'readOnly',
  disabled: 'disabled',
  value: 'value',
  autocomplete: 'autocomplete'
}
,{
  valueChange: 'valueChange',
  onActivateLink: 'onActivateLink'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/date-field/date-field.component.ngfactory.ts